import { registerTldrawLibraryVersion } from "./lib/version.mjs";
import { default as default2 } from "lodash.throttle";
import { default as default3 } from "lodash.uniq";
import { ExecutionQueue } from "./lib/ExecutionQueue.mjs";
import { PerformanceTracker } from "./lib/PerformanceTracker.mjs";
import {
  areArraysShallowEqual,
  compact,
  dedupe,
  last,
  maxBy,
  mergeArraysAndReplaceDefaults,
  minBy,
  partition,
  rotateArray
} from "./lib/array.mjs";
import { bind } from "./lib/bind.mjs";
import { WeakCache } from "./lib/cache.mjs";
import {
  Result,
  assert,
  assertExists,
  exhaustiveSwitchError,
  promiseWithResolve,
  sleep
} from "./lib/control.mjs";
import { debounce } from "./lib/debounce.mjs";
import { annotateError, getErrorAnnotations } from "./lib/error.mjs";
import { FileHelpers } from "./lib/file.mjs";
import { noop, omitFromStackTrace } from "./lib/function.mjs";
import { getHashForBuffer, getHashForObject, getHashForString, lns } from "./lib/hash.mjs";
import { mockUniqueId, restoreUniqueId, uniqueId } from "./lib/id.mjs";
import { getFirstFromIterable } from "./lib/iterable.mjs";
import {
  DEFAULT_SUPPORTED_IMAGE_TYPES,
  DEFAULT_SUPPORTED_MEDIA_TYPE_LIST,
  DEFAULT_SUPPORT_VIDEO_TYPES,
  MediaHelpers
} from "./lib/media/media.mjs";
import { PngHelpers } from "./lib/media/png.mjs";
import { Image, fetch } from "./lib/network.mjs";
import { invLerp, lerp, modulate, rng } from "./lib/number.mjs";
import {
  areObjectsShallowEqual,
  filterEntries,
  getOwnProperty,
  groupBy,
  hasOwnProperty,
  mapObjectMapValues,
  objectMapEntries,
  objectMapFromEntries,
  objectMapKeys,
  objectMapValues
} from "./lib/object.mjs";
import { measureAverageDuration, measureCbDuration, measureDuration } from "./lib/perf.mjs";
import {
  ZERO_INDEX_KEY,
  getIndexAbove,
  getIndexBelow,
  getIndexBetween,
  getIndices,
  getIndicesAbove,
  getIndicesBelow,
  getIndicesBetween,
  sortByIndex,
  validateIndexKey
} from "./lib/reordering.mjs";
import { retry } from "./lib/retry.mjs";
import { sortById } from "./lib/sort.mjs";
import {
  clearLocalStorage,
  clearSessionStorage,
  deleteFromLocalStorage,
  deleteFromSessionStorage,
  getFromLocalStorage,
  getFromSessionStorage,
  setInLocalStorage,
  setInSessionStorage
} from "./lib/storage.mjs";
import { stringEnum } from "./lib/stringEnum.mjs";
import { fpsThrottle, throttleToNextFrame } from "./lib/throttle.mjs";
import { Timers } from "./lib/timers.mjs";
import { safeParseUrl } from "./lib/url.mjs";
import {
  STRUCTURED_CLONE_OBJECT_PROTOTYPE,
  isDefined,
  isNativeStructuredClone,
  isNonNull,
  isNonNullish,
  structuredClone
} from "./lib/value.mjs";
import { registerTldrawLibraryVersion as registerTldrawLibraryVersion2 } from "./lib/version.mjs";
import { warnDeprecatedGetter, warnOnce } from "./lib/warn.mjs";
registerTldrawLibraryVersion(
  "@tldraw/utils",
  "3.11.1",
  "esm"
);
export {
  DEFAULT_SUPPORTED_IMAGE_TYPES,
  DEFAULT_SUPPORTED_MEDIA_TYPE_LIST,
  DEFAULT_SUPPORT_VIDEO_TYPES,
  ExecutionQueue,
  FileHelpers,
  Image,
  MediaHelpers,
  PerformanceTracker,
  PngHelpers,
  Result,
  STRUCTURED_CLONE_OBJECT_PROTOTYPE,
  Timers,
  WeakCache,
  ZERO_INDEX_KEY,
  annotateError,
  areArraysShallowEqual,
  areObjectsShallowEqual,
  assert,
  assertExists,
  bind,
  clearLocalStorage,
  clearSessionStorage,
  compact,
  debounce,
  dedupe,
  deleteFromLocalStorage,
  deleteFromSessionStorage,
  exhaustiveSwitchError,
  fetch,
  filterEntries,
  fpsThrottle,
  getErrorAnnotations,
  getFirstFromIterable,
  getFromLocalStorage,
  getFromSessionStorage,
  getHashForBuffer,
  getHashForObject,
  getHashForString,
  getIndexAbove,
  getIndexBelow,
  getIndexBetween,
  getIndices,
  getIndicesAbove,
  getIndicesBelow,
  getIndicesBetween,
  getOwnProperty,
  groupBy,
  hasOwnProperty,
  invLerp,
  isDefined,
  isNativeStructuredClone,
  isNonNull,
  isNonNullish,
  last,
  lerp,
  lns,
  mapObjectMapValues,
  maxBy,
  measureAverageDuration,
  measureCbDuration,
  measureDuration,
  mergeArraysAndReplaceDefaults,
  minBy,
  mockUniqueId,
  modulate,
  noop,
  objectMapEntries,
  objectMapFromEntries,
  objectMapKeys,
  objectMapValues,
  omitFromStackTrace,
  partition,
  promiseWithResolve,
  registerTldrawLibraryVersion2 as registerTldrawLibraryVersion,
  restoreUniqueId,
  retry,
  rng,
  rotateArray,
  safeParseUrl,
  setInLocalStorage,
  setInSessionStorage,
  sleep,
  sortById,
  sortByIndex,
  stringEnum,
  structuredClone,
  default2 as throttle,
  throttleToNextFrame,
  default3 as uniq,
  uniqueId,
  validateIndexKey,
  warnDeprecatedGetter,
  warnOnce
};
//# sourceMappingURL=index.mjs.map
